// organize-imports-ignore
import '../base';
import { initCompanyDesign } from './react/services/CompanyDesignProvider';
import { loadCurrentUser } from './react/services/CurrentUser';
import { isFeatureEnabledForUser } from './react/services/Features';
import { loadGlossary } from './react/services/Glossary';
import { renderInitialLoadingError } from './render-error';
import './style.static.less';

(async () => {
    initCompanyDesign();
    try {
        const currentUser = await loadCurrentUser();
        if (isFeatureEnabledForUser('FEATURE_glossary', currentUser)) {
            loadGlossary();
        }
        await import(/* webpackChunkName: 'si-app-main', webpackPreload: true */ './index');
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        renderInitialLoadingError(error);
    }
})();
